const message_route = [
  {
    path: '/message',
    name: "message",
    component: resolve => {
      require(["@/views/manage/message/Index.vue"], resolve);
    },
    redirect: { path: "/message/msgpushset" },
    meta: {
      public: false,
      title: '消息配置',
      navtype: 1,
      active: ['/message/messageset','/message/msgpushset','/message/emailset']
    },
    children: [
      {
        path: 'messageset',
        name: "messageset",
        component: resolve => {
          require(["@/views/manage/message/MsgSet.vue"], resolve);
        },
        meta: {
          public: false,
          title: '短信配置',
          navtype: 1,
          id:[10056],
          active: ['/message/messageset','/message/msgpushset','/message/emailset']
        }
      },
      {
        path: 'emailset',
        name: "emailset",
        component: resolve => {
          require(["@/views/manage/message/EmailSet.vue"], resolve);
        },
        meta: {
          public: false,
          title: '邮件配置',
          navtype: 1,
          id:[10057],
          active: ['/message/messageset','/message/msgpushset','/message/emailset']
        }
      },
      // {
      //   path: 'messageedit',
      //   name: "messageedit",
      //   component: resolve => {
      //     require(["@/views/manage/message/MsgEdit.vue"], resolve);
      //   },
      //   meta: {
      //     public: false,
      //     title: '消息编辑',
      //     navtype: 1,
      //     id:[10063],
      //     active: ['/message/messageset','/message/msgpushset','/message/emailset']
      //   }
      // },
      // {
      //   path: 'msgpushset',
      //   name: "msgpushset",
      //   component: resolve => {
      //     require(["@/views/manage/message/MsgPushSet.vue"], resolve);
      //   },
      //   meta: {
      //     public: false,
      //     title: '消息推送配置',
      //     navtype: 1,
      //     id:[10058],
      //     active: ['/message/messageset','/message/msgpushset','/message/emailset']
      //   }
      // },

      {
        path: 'msgpushsetindex',
        redirect: "/message/msgpushset",
        name: "msgpushset",
        component: resolve => {
          require(["@/views/manage/message/MsgPushSetIndex.vue"], resolve);
        },
        meta: {
          public: false,
          title: '消息推送配置',
          navtype: 1,
          id:[10058],
          active: ['/message/messageset','/message/msgpushset','/message/emailset']
        },
        children: [
          {
            path: '/message/msgpushset',
            name: "msgpushset",
            component: resolve => {
              require(["@/views/manage/message/MsgPushSet.vue"], resolve);
            },
            meta: {
              public: false,
              navtype: 1,
              id:[10058],
              active: ['/message/messageset','/message/msgpushset','/message/emailset']
            },
          },
          {
            path: '/message/messageedit',
            name: "messageedit",
            component: resolve => {
              require(["@/views/manage/message/MsgEdit.vue"], resolve);
            },
            meta: {
              public: false,
              title: '消息编辑',
              navtype: 1,
              id:[10063],
              active: ['/message/messageset','/message/msgpushset','/message/emailset']
            }
          },
        ]
      },
    ]
  },
];
export default message_route